export const HOMEPAGE = "/";
export const LOGIN = "/login";
export const REGISTER = "/register";
export const ADD_PRODUCTS_AGENTS = "/a/add-product";
export const VIEW_PRODUCTS_AGENTS = "/a/products";
export const VIEW_STORES = "/a/stores"
export const ADD_STORE_AGENTS = "/a/add-store";
export const DASHBOARD_CLIENT = "/u/profile";
export const AGENT_LOGIN = "/a";